import styled from 'styled-components';

const InnerContainer = styled.div`
    max-width:1200px;
    margin: 0 auto;
`
export { InnerContainer}